import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { loading: true, data: false, error: false };

export function reloadValidatorReducer(state = initialState, action) {
   
    switch (action.type) {
        case AnalyzeConstants.RELOAD_FALSE:
        return {
            loading: false,
            data: false,
            error: false
        };
        case AnalyzeConstants.RELOAD_TRUE:
            return {
                loading: false,
                data: true,
                error: false
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/reloadValidatorReducer.reducer.js